module.exports = __webpack_public_path__ + "5424c5e1ea2b189b66727d2a39c44180.svg";